import { apiClient } from "../api/apiClient";

import {
  ApiResponse,
  Brand,
  CreateBrandRequest
} from "../interfaces/Brand";

// ======================================
// BRAND SERVICE
// ======================================

export const brandService = {

  // ======================================
  // GET ALL  
  // ======================================

getAll: async (): Promise<Brand[]> => {
  const response =
    await apiClient.get<ApiResponse<Brand>>("/Brands/GetAll");

  const result = response.data;

  if (!result.isSuccess) {
    throw new Error(result.message);
  }

  return result.dataList ?? [];
},

  // ======================================
  // GET BY ID
  // ======================================

  getById: async (
    id: number
  ): Promise<Brand> => {

    const response =
      await apiClient.get<
        ApiResponse<Brand>
      >(
        `/Brands/${id}`
      );

    const result =
      response.data;

    if (!result.isSuccess) {
      throw new Error(result.message);
    }

    if (!result.data) {
      throw new Error("Brand not found");
    }

    return result.data;
  },

  // ======================================
  // CREATE
  // ======================================

  create: async (
    payload: CreateBrandRequest
  ) => {

    const formData = new FormData();

    formData.append("BrandName", payload.brandName);
    formData.append("BrandSlug", payload.brandSlug);

    formData.append("Description", payload.description || "");

    formData.append("WebsiteURL", payload.websiteURL || "");
    formData.append("ContactEmail", payload.contactEmail || "");
    formData.append("ContactNumber", payload.contactNumber || "");

    formData.append("IsFeatured", String(payload.isFeatured ?? false));
    formData.append("DisplayOrder", String(payload.displayOrder ?? 0));
   formData.append(
  "Status",
  payload.status === "Active"
    ? "true"
    : "false"
);
    // SEO
    formData.append("MetaTitle", payload.metaTitle || "");
    formData.append("MetaDescription", payload.metaDescription || "");
    formData.append("MetaKeywords", payload.metaKeywords || "");
    formData.append("CanonicalUrl", payload.canonicalUrl || "");

    // OG
    formData.append("OgTitle", payload.ogTitle || "");
    formData.append("OgDescription", payload.ogDescription || "");
    formData.append("SchemaMarkup", payload.schemaMarkup || "");

    // FILES
    if (payload.brandLogo) {
      formData.append("BrandLogo", payload.brandLogo);
    }

    if (payload.brandImage) {
      formData.append("BrandImage", payload.brandImage);
    }

    if (payload.ogImage) {
      formData.append("OgImage", payload.ogImage);
    }

    const response =
      await apiClient.post(
        "/Brands/Create",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        }
      );

    return response.data;
  },

  // ======================================
  // UPDATE
  // ======================================

  update: async (
    payload: CreateBrandRequest & {
      brandID: number;
    }
  ) => {

    const formData = new FormData();

    formData.append("BrandID", payload.brandID.toString());

    formData.append("BrandName", payload.brandName);
    formData.append("BrandSlug", payload.brandSlug);

    formData.append("Description", payload.description || "");

    formData.append("WebsiteURL", payload.websiteURL || "");
    formData.append("ContactEmail", payload.contactEmail || "");
    formData.append("ContactNumber", payload.contactNumber || "");

    formData.append("IsFeatured", String(payload.isFeatured ?? false));
    formData.append("DisplayOrder", String(payload.displayOrder ?? 0));

    // SEO
    formData.append("MetaTitle", payload.metaTitle || "");
    formData.append("MetaDescription", payload.metaDescription || "");
    formData.append("MetaKeywords", payload.metaKeywords || "");
    formData.append("CanonicalUrl", payload.canonicalUrl || "");

    // OG
    formData.append("OgTitle", payload.ogTitle || "");
    formData.append("OgDescription", payload.ogDescription || "");
    formData.append("SchemaMarkup", payload.schemaMarkup || "");

    // FILES
    if (payload.brandLogo) {
      formData.append("BrandLogo", payload.brandLogo);
    }

    if (payload.brandImage) {
      formData.append("BrandImage", payload.brandImage);
    }

    if (payload.ogImage) {
      formData.append("OgImage", payload.ogImage);
    }

    const response =
      await apiClient.put(
        "/Brands/Update",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        }
      );

    return response.data;
  },

  // ======================================
  // DELETE
  // ======================================

  delete: async (
    id: number
  ) => {

    const response =
      await apiClient.delete(
        `/Brands/${id}`
      );

    return response.data;
  },

 

  
  // =========================
  // DUPLICATE BRAND CHECK
  // =========================
  validateDuplicateBrand: (
    brands: Brand[],
    brandName: string,
    editingBrandId: number | null
  ): boolean => {

    const duplicate = brands.some(
      b =>
        b.brandName
          .trim()
          .toLowerCase() ===
        brandName
          .trim()
          .toLowerCase()

        &&

        b.brandID !== editingBrandId
    );

    return !duplicate;
  },

     


};